__turbopack_context__.v({
  "cardImage": "Card-module__Mmkqya__cardImage",
  "cardLink": "Card-module__Mmkqya__cardLink",
  "date": "Card-module__Mmkqya__date",
  "electric": "Card-module__Mmkqya__electric",
  "figure": "Card-module__Mmkqya__figure",
  "root": "Card-module__Mmkqya__root",
});
